













import {
  Vue,
  Component,
} from "@/shared/vuepack";

@Component ({})

export default class ImpersonationError extends Vue {
}
